import React from 'react';
import './App.css';
import { Switch } from 'react-router-dom';
import Routes from './routes.js';

function App() {
  return (
    <Switch>
      <Routes />
    </Switch>
  );
}

export default App;
